module.exports = __webpack_public_path__ + "static/media/light_dashboard_bg.eb336c92.jpg";